/**
 * Example shared formatting helper. Formatting, normalization, and general
 * utility functions live in `lib/src/helpers` so both the API and web app
 * format the same value the same way.
 */
export function formatDate(
  value: string | Date,
  locale = 'en-US',
): string {
  const date = typeof value === 'string' ? new Date(value) : value
  return date.toLocaleDateString(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}

/**
 * Date and time of day, for events where the hour matters.
 *
 * A proposal delivery is one: "sent 29 Sep" and "sent 29 Sep, 4:12 PM" answer
 * different questions when somebody is working out whether a client had it
 * before a board meeting.
 */
export function formatDateTime(
  value: string | Date,
  locale = 'en-US',
): string {
  const date = typeof value === 'string' ? new Date(value) : value
  return date.toLocaleString(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}
